import { useMemo } from "react";
import { createFileRoute } from "@tanstack/react-router";

import { Dimension } from "@/components/brand-governance/compliance-tracker/by-dimension";
import { ScoreTrend } from "@/components/brand-governance/compliance-tracker/score-trend";
import { SubBrandCompliance } from "@/components/brand-governance/compliance-tracker/sub-brand-compliance";
import { PageHeader } from "@/components/layout/heading";

import { useSession } from "@/hooks/use-session";

export const Route = createFileRoute("/dashboard/governance/_layout/compliance-tracker")({
  component: ComplianceTracker,
});

export function ComplianceTracker() {
  const session = useSession();
  const brandName = session.profile.company?.company_name ?? "";

  const scorecardParams = useMemo(() => ({ brand_name: brandName, channels: [], sub_brands: [], period: "last_30d" }), [brandName]);

  return (
    <div className="space-y-6">
      <PageHeader title="Compliance Deep Drive" />
      <ScoreTrend params={scorecardParams} />
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
        <Dimension params={scorecardParams} />
        <SubBrandCompliance params={scorecardParams} />
      </div>
    </div>
  );
}
